/* eslint-disable camelcase */
// import required from './required'
import password from './password'
import repeatChar from './repeatChar'
import distinct from './distinct'
import idcheck from './idcheck'
import passwordChar from './passwordChar'
import passwordLength from './passwordLength'

export default {
  // required,
  idcheck,
  distinct,
  password,
  repeatChar,
  passwordChar,
  passwordLength
}



// WEBPACK FOOTER //
// ./src/config/validate/rules/index.js